module.exports = __webpack_public_path__ + "img/inicial.72c43083.png";